(function() {
  /* ══════════ CASEMIRA i18n R2c · LE NOM DE L'OPTION EST TRADUIT ══════════
     Ce script cherchait l'option de taille par la chaine litterale « Taille »,
     dans un selecteur `[data-option-name="Taille"]` et dans le texte d'une
     legende. L'usine de traduction a traduit le NOM des options : en /en le
     Liquid peint `data-option-name="Size"`, en /de « Größe ». Les trois tests
     tombaient a faux et le carrousel ne suivait plus le changement de variante.

     La resolution est faite UNE fois cote serveur par
     snippets/casemira-options-map.liquid et publiee dans
     `FoxTheme.casemira.options` : `taille` porte l'INDEX 1-base de l'option qui
     joue ce role, `noms` la liste des noms d'option TELS QU'AFFICHES. On lit le
     nom a l'index, et on retombe sur « Taille » si la table est absente
     (page servie sans le pont, ou zone jamais remplie) : jamais `undefined`.

     DEUX SOURCES, dans cet ordre. Le pont `FoxTheme.casemira.options`, pose
     dans l'entete par snippets/casemira-js-strings.liquid ; a defaut les
     `data-cm-opt-*` que sections/main-product.liquid pose sur `.product`, avec
     la meme resolution et le meme snippet. La seconde couvre le cas ou le
     produit courant n'est pas visible depuis le gabarit, et les pages rendues
     par la Section Rendering API. */
  function carteOptions() {
    var O = (window.FoxTheme && FoxTheme.casemira && FoxTheme.casemira.options) || null;
    if (O && O.taille) return O;
    var hote = document.querySelector('[data-cm-opt-taille]');
    if (!hote) return O || {};
    var noms = [];
    try { noms = JSON.parse(hote.getAttribute('data-cm-opt-noms') || '[]'); } catch (e) {}
    return { taille: parseInt(hote.getAttribute('data-cm-opt-taille'), 10) || 0, noms: noms };
  }

  function nomOptionTaille() {
    var O = carteOptions();
    var noms = O.noms || [];
    var i = O.taille || 0;
    return (i > 0 && noms[i - 1]) || 'Taille';
  }

  /* Le nom d'option peut contenir un guillemet ou un accent : on ne le
     concatene pas dans un selecteur CSS, on filtre en JS.
     Le Liquid pose `data-option-name` sur plusieurs elements d'une meme option
     (le fieldset, les etiquettes, le select) : on les parcourt TOUS, comme le
     faisait le selecteur groupe d'origine, et on rend le premier qui porte une
     valeur choisie. */
  function valeurChoisieTaille(racine) {
    var nom = nomOptionTaille();
    var els = (racine || document).querySelectorAll('[data-option-name]');
    for (var i = 0; i < els.length; i++) {
      if (els[i].getAttribute('data-option-name') !== nom) continue;
      var actif = els[i].querySelector('.is-active') || els[i].querySelector('input:checked');
      if (actif) return actif;
    }
    return null;
  }

  /* Vrai si l'evenement vient de l'option qui porte la taille. Remplace un
     `closest('[data-option-name="Taille"]')`. */
  function vientDeLOptionTaille(cible) {
    var nom = nomOptionTaille();
    var el = cible && cible.closest ? cible.closest('[data-option-name]') : null;
    while (el) {
      if (el.getAttribute('data-option-name') === nom) return true;
      el = el.parentElement && el.parentElement.closest
        ? el.parentElement.closest('[data-option-name]')
        : null;
    }
    return false;
  }

  /* Les valeurs d'option sont traduites elles aussi : « Largeur 60 cm »
     devient « Width 60 cm ». Le carrousel doit ecarter ces valeurs dans
     toutes les langues, pas seulement en francais.
     03/10/2026 : la liste vient du serveur (`FoxTheme.casemira.options
     .prefixes_largeur`, ecrite UNE fois dans snippets/casemira-options-map.liquid,
     socle commun plus la cle de la locale courante). La liste ci-dessous n'est que
     le repli d'une page servie sans le pont ; elle connait l'italien et l'espagnol,
     et depuis le 04/10 le portugais, le tcheque, le slovaque et le danois
     (puis le hongrois, le croate et le roumain, puis le suedois, le finnois et le grec ;
     le 06/10 le bulgare, le letton, l'estonien et le lituanien, « Širina » slovene etant deja la par le croate). */
  var PREFIXES_LARGEUR = (function () {
    var O = (window.FoxTheme && FoxTheme.casemira && FoxTheme.casemira.options) || {};
    if (O.prefixes_largeur && O.prefixes_largeur.length) return O.prefixes_largeur;
    return ['Largeur', 'Width', 'Breite', 'Breedte', 'Larghezza', 'Ancho', 'Largura', 'Šířka', 'Šírka', 'Bredde', 'Szélesség', 'Širina', 'Lățime', 'Lăţime', 'Bredd', 'Leveys', 'Πλάτος', 'Ширина', 'Platums', 'Laius', 'Plotis'];
  })();

  function estUneLargeur(s) {
    for (var i = 0; i < PREFIXES_LARGEUR.length; i++) {
      if (s.indexOf(PREFIXES_LARGEUR[i]) !== -1) return true;
    }
    return false;
  }

  /* i18n R2b : table lue UNE fois, avant la boucle, repli code
     (CONVENTION.md § 3). */
  var S = (window.FoxTheme && window.FoxTheme.casemira && window.FoxTheme.casemira.fiche) || {};

  function avec(modele, jeton, valeur) {
    return String(modele).split(jeton).join(valeur);
  }

  document.querySelectorAll('.dim-carousel').forEach(function(container) {
    if (container.dataset.dimInit) return;
    container.dataset.dimInit = 'true';

    var rawSizes = JSON.parse(container.dataset.sizes || '[]');
    var forme = container.dataset.forme || 'rectangle';
    var isOutdoor = container.dataset.outdoor === 'true';
    var filesBase = container.dataset.filesBase || '';

    var slides = [];

    rawSizes.forEach(function(raw) {
      var s = raw.trim();
      var filename = null;
      var label = s;

      /* Skip kits et largeurs */
      if (s.indexOf('+') !== -1) return;
      if (estUneLargeur(s)) return;

      /* Rond : "Ø200 cm" ou "ø200 cm" */
      if (s.indexOf('\u00D8') !== -1 || s.indexOf('\u00F8') !== -1) {
        var d = s.replace(/[\u00D8\u00F8\s]/g, '').replace('cm', '');
        filename = d + 'cm_diametre_rond';
      }
      /* Rectangle / Ovale / Carré : "80 x 150 cm" ou "80 × 150 cm" */
      else {
        /*
         * FIX CRITIQUE : gère à la fois :
         *   "x" (lettre latine, U+0078)
         *   "×" (signe multiplication, U+00D7)
         *   "X" (lettre majuscule)
         * Shopify et certains thèmes utilisent l'un ou l'autre
         */
        var cleaned = s.replace(/\s*cm\s*$/i, '').replace(/\s*[x\u00D7]\s*/gi, 'x').trim();
        var parts = cleaned.split('x');
        if (parts.length === 2) {
          var w = parseInt(parts[0], 10);
          var h = parseInt(parts[1], 10);
          if (isNaN(w) || isNaN(h)) return;
          filename = w + 'x' + h + 'cm';
          if (w === h) { filename += '_carre'; }
          else if (forme.indexOf('ovale') !== -1) { filename += '_ovale'; }
        } else { return; }
      }

      if (!filename) return;
      if (isOutdoor) { filename += '_exterieur'; }

      slides.push({ label: label, filename: filename });
    });

    if (slides.length === 0) { container.style.display = 'none'; return; }

    var img = container.querySelector('.dim-carousel__img');
    var prevBtn = container.querySelector('.dim-arrow--prev');
    var nextBtn = container.querySelector('.dim-arrow--next');
    var counter = container.querySelector('.dim-carousel__counter');
    var subtitle = container.querySelector('.dim-carousel__subtitle');
    var currentIndex = 0;
    var locked = false;

    var urlCache = {};

    if (slides.length > 1) {
      subtitle.textContent = avec(S.dimNaviguez || 'Naviguez entre les [n] dimensions pour les comparer',
                                  '[n]', slides.length);
    }

    function resolveUrl(filename, callback) {
      if (urlCache[filename]) { callback(urlCache[filename]); return; }
      if (urlCache[filename] === false) { callback(null); return; }
      var test = new Image();
      var url = filesBase + filename + '.webp';
      test.onload = function() { urlCache[filename] = url; callback(url); };
      test.onerror = function() { urlCache[filename] = false; callback(null); };
      test.src = url;
    }

    function preloadSlide(idx) {
      if (idx < 0 || idx >= slides.length) return;
      resolveUrl(slides[idx].filename, function() {});
    }

    function preloadAround(idx) {
      preloadSlide(idx - 1);
      preloadSlide(idx + 1);
      preloadSlide(idx + 2);
    }

    function showSlide(idx) {
      if (idx < 0 || idx >= slides.length) return;
      currentIndex = idx;
      img.classList.add('dim-loading');

      resolveUrl(slides[idx].filename, function(url) {
        if (url) {
          img.src = url;
          img.alt = avec(S.dimIllustration || 'Illustration [t]', '[t]', slides[idx].label);
        } else {
          img.src = '';
          img.alt = S.dimIllustrationIndispo || 'Illustration indisponible';
        }
        img.classList.remove('dim-loading');
      });

      preloadAround(idx);
      counter.textContent = slides[idx].label + '  \u00b7  ' + (idx + 1) + ' / ' + slides.length;
      prevBtn.disabled = (idx === 0);
      nextBtn.disabled = (idx === slides.length - 1);
      if (slides.length <= 1) { prevBtn.style.display = 'none'; nextBtn.style.display = 'none'; }
    }

    function findSlideForSize(sizeValue) {
      for (var i = 0; i < slides.length; i++) { if (slides[i].label === sizeValue) return i; }
      return 0;
    }

    prevBtn.addEventListener('click', function() { if (currentIndex > 0) showSlide(currentIndex - 1); });
    nextBtn.addEventListener('click', function() { if (currentIndex < slides.length - 1) showSlide(currentIndex + 1); });

    function getSelectedSize() {
      var nomTaille = nomOptionTaille();
      var activeOption = valeurChoisieTaille(document);
      if (activeOption) return activeOption.value || activeOption.textContent.trim();
      var fieldsets = document.querySelectorAll('fieldset, .product-form__option');
      for (var i = 0; i < fieldsets.length; i++) {
        var legend = fieldsets[i].querySelector('legend, .product-form__option-label');
        if (legend && legend.textContent.indexOf(nomTaille) !== -1) {
          var checked = fieldsets[i].querySelector('input:checked, .is-active');
          if (checked) return checked.value || checked.textContent.trim();
        }
      }
      var urlParams = new URLSearchParams(window.location.search);
      var variantId = urlParams.get('variant');
      if (variantId && window.ShopifyProduct) {
        var variants = window.ShopifyProduct.variants || [];
        for (var j = 0; j < variants.length; j++) {
          if (String(variants[j].id) === variantId) return variants[j].option1;
        }
      }
      return null;
    }

    var selectedSize = getSelectedSize();
    var initialIdx = selectedSize ? findSlideForSize(selectedSize) : 0;
    showSlide(initialIdx);
    container.style.display = '';

    var accordion = container.closest('details');
    if (accordion) {
      accordion.addEventListener('toggle', function() {
        if (accordion.open && !locked) {
          var size = getSelectedSize();
          if (size) showSlide(findSlideForSize(size));
          locked = true;
        }
      });
    }

    function onVariantChange() {
      if (locked) return;
      var size = getSelectedSize();
      if (size) showSlide(findSlideForSize(size));
    }

    document.addEventListener('change', function(e) {
      if (vientDeLOptionTaille(e.target) ||
          (e.target.name && e.target.name.indexOf('option') !== -1)) {
        setTimeout(onVariantChange, 50);
      }
    });

    var lastUrl = location.href;
    var urlObserver = new MutationObserver(function() {
      if (location.href !== lastUrl) { lastUrl = location.href; onVariantChange(); }
    });
    urlObserver.observe(document.querySelector('head > title') || document.head, { childList: true, subtree: true });
  });
})();
